
export default () => ({
  form: {
    sumPerPerson: null
  },
  penalties: {
    isLoading: true,
    hasError: false,
    collection: [],
    errors: []
  },
})
